import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { failedUploadsSelector, setUploadsResumedAction, useUploaderStore } from '@air/redux-uploader';

export const useRetryAllUploads = () => {
  const dispatch = useDispatch();
  const store = useUploaderStore();

  const retryAllUploads = useCallback(() => {
    const failedUploads = failedUploadsSelector(store.getState());
    dispatch(setUploadsResumedAction({ uploadIds: failedUploads.map(({ id }) => id) }));
  }, [dispatch, store]);

  return {
    retryAllUploads,
  };
};
